import Button from '@doordash/component-button'
import Toggle from '@doordash/component-toggle'
import { StackChildren, Text } from '@doordash/design-language'
import * as React from 'react'
import { connect } from 'react-redux'
import { BackgroundCheck as Tag } from '../../../../models/selectorAnchors'
import { getBGCFormExperiment } from '../../../../selectors/identificationStep'
import * as DA from '../../../../typeModules/events'
import Form from '../../../../utilities/Form'
// tslint:disable-next-line:max-line-length
import { validators as sharedValidators } from '../../../../utilities/validators'
import {
  DocumentAcceptanceModal,
  DocumentTypes,
} from '../../../molecules/document-acceptance-modal'
import { IdentificationDataType } from '.././types'
import t from '../strings'
import { BGCInfoPreview } from './BGCForm'

type Props = {
  needsLicenseInfo: boolean
  uniqueLink?: string
  requestedBgCheckCopy?: boolean
  error?: string
  onSubmit?: any
  trackBackgroundCheckSteps: (data: DA.TrackBackgroundCheck) => Promise<any>
  identificationData?: IdentificationDataType
  setIdentificationData?: React.Dispatch<React.SetStateAction<object>>
}

type ReduxProps = {
  experiments?: object
}

class DisclosureStep extends React.Component<Props & ReduxProps> {
  public static fields = {
    requestedBgCheckCopy: false,
  }

  public static defaultProps = {
    requestedBgCheckCopy: false,
  }

  public static validators: any = {
    requestedBgCheckCopy: sharedValidators.requestedBgCheckCopy,
  }
  public componentDidMount() {
    this.props.trackBackgroundCheckSteps({
      page: DA.BackgroundCheckPages.Disclosures,
      action: DA.EventActions.Rendered,
    })
  }

  public render() {
    const isBGCFormExperimentOn = getBGCFormExperiment({
      experiments: this.props.experiments,
    })

    return (
      <React.Fragment>
        <Text styles={Text.Styles.PageTitle}>
          {isBGCFormExperimentOn ? t.disclosureTitleNew() : t.disclosureTitle()}
        </Text>
        <StackChildren>
          {isBGCFormExperimentOn && (
            <BGCInfoPreview
              identificationData={this.props.identificationData}
              setIdentificationData={this.props.setIdentificationData}
              needsLicenseInfo={this.props.needsLicenseInfo}
            />
          )}
          <div>
            <DocumentAcceptanceModal
              type={DocumentTypes.BackgroundCheckDisclosure}
              anchorId={Tag.BackgroundCheckDisclosure}
            />
            <DocumentAcceptanceModal
              type={DocumentTypes.AdditionalDisclosuresDocument}
              anchorId={Tag.AdditionalDisclosuresDocument}
            />
            <DocumentAcceptanceModal
              type={DocumentTypes.AuthAndReleaseDocument}
              anchorId={Tag.AuthAndReleaseDocument}
            />
          </div>
          <Form
            onSubmit={this.props.onSubmit}
            validators={DisclosureStep.validators}
            fields={DisclosureStep.fields}
          >
            {(fields, handleChange, handleSubmit, { isLoading }) => (
              <form onSubmit={handleSubmit}>
                <StackChildren>
                  <div data-anchor-id={Tag.BackgroundCheckCopyToggle}>
                    <Toggle
                      accessibilityDescribedBy={'receivedBackgroundCheckCopy'}
                      label={t.receivesCopy()}
                      alignToggle={Toggle.Alignment.Center}
                      type={Toggle.Types.Checkbox}
                      onChange={handleChange.bind(this, 'requestedBgCheckCopy')}
                      isSelected={fields.requestedBgCheckCopy.value}
                    />
                  </div>

                  <Text
                    styles={Text.Styles.PageSubtext}
                    lineHeight={Text.LineHeights.Large}
                  >
                    {t.terms()}
                  </Text>
                  <Button
                    accessibilityDescribedBy={'submitBackgroundCheck'}
                    onClick={async () => {
                      this.props.trackBackgroundCheckSteps({
                        page: DA.BackgroundCheckPages.Disclosures,
                        action: DA.EventActions.Continue,
                      })
                      try {
                        await handleSubmit()
                      } catch (e) {
                        this.props.trackBackgroundCheckSteps({
                          page: DA.BackgroundCheckPages.Disclosures,
                          action: DA.EventActions.Error,
                          value: e,
                        })
                      }
                    }}
                    state={
                      isLoading ? Button.States.Loading : Button.States.Default
                    }
                    data-anchor-id={Tag.PrimaryAction}
                  >
                    {t.continue()}
                  </Button>
                </StackChildren>
              </form>
            )}
          </Form>
        </StackChildren>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({
  experiments: state.experiments,
})

export default connect(mapStateToProps)(DisclosureStep)
